import React from 'react';
import { Search } from 'baseui/icon';
import classes from './SearchBefore.module.scss';

export const SearchBefore: React.FC = () => (
  <div className={classes.searchIcon}>
    <Search size='18pt' />
  </div>
);
